require('dotenv').config()


export default "Etc/GMT+1";